import React from "react";
import { Card, Nav, Pagination } from "react-bootstrap";
import { showPageNumbers } from "../../utils/table";
import Select from "react-select";
import { usePagination } from "../../context/TableContext.v2";
import clsx from "clsx";
import styles from "./index.module.css";

const paginationOptions = [
  { value: 10, label: "10" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
];

const GlobalPagination = ({ forceShowPagination = false }) => {
  const {
    currentPage,
    setCurrentPage,
    itemsPerPage,
    setItemsPerPage,
    totalDocs,
  } = usePagination();

  const totalPages = itemsPerPage ? Math.ceil(totalDocs / itemsPerPage) : 0;
  const showPaginationNumbers = forceShowPagination || totalPages > 10;

  return (
    <Card.Footer
      className={clsx(
        "px-3 border-0 d-lg-flex justify-content-between",
        styles.stickyFooter
      )}
    >
      <Nav>
        <Pagination className="mb-2 mb-lg-0">
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Previous
          </Pagination.Prev>
          {showPaginationNumbers && (
            <>
              {currentPage > 4 && (
                <>
                  <Pagination.Item onClick={() => setCurrentPage(1)}>
                    1
                  </Pagination.Item>
                  <Pagination.Ellipsis disabled />
                </>
              )}
              {[...Array(totalPages)].map((_, page) => {
                if (showPageNumbers(page, currentPage, totalPages)) {
                  return (
                    <Pagination.Item
                      key={page + 1}
                      active={page + 1 === currentPage}
                      onClick={() => setCurrentPage(page + 1)}
                    >
                      {page + 1}
                    </Pagination.Item>
                  );
                }
                return null;
              })}
              {currentPage < totalPages - 3 && (
                <>
                  <Pagination.Ellipsis disabled />
                  <Pagination.Item onClick={() => setCurrentPage(totalPages)}>
                    {totalPages}
                  </Pagination.Item>
                </>
              )}
            </>
          )}
          <Pagination.Next
            onClick={() =>
              setCurrentPage((prev) =>
                Math.min(prev + 1, Math.ceil(totalDocs / itemsPerPage))
              )
            }
            disabled={currentPage === totalPages || totalPages === 0}
          >
            Next
          </Pagination.Next>
        </Pagination>
      </Nav>

      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        Items Per Page
        <Select
          options={paginationOptions}
          defaultValue={paginationOptions.find(
            (opt) => opt.value === itemsPerPage
          )}
          onChange={(selected) => {
            if (selected) {
              setItemsPerPage(selected.value);
              setCurrentPage(1);
            }
          }}
          styles={{
            control: (provided) => ({
              ...provided,
              minHeight: "32px",
              height: "32px",
              fontSize: "14px",
            }),
            valueContainer: (provided) => ({
              ...provided,
              height: "32px",
              padding: "0 6px",
            }),
            indicatorsContainer: (provided) => ({
              ...provided,
              height: "32px",
            }),
            option: (provided) => ({
              ...provided,
              fontSize: "14px",
              padding: "6px 12px",
              minHeight: "28px",
            }),
            menuList: (provided) => ({
              ...provided,
              paddingTop: 0,
              paddingBottom: 0,
            }),
          }}
          menuPlacement="top"
        />
      </div>
    </Card.Footer>
  );
};

export default GlobalPagination;
